export class DoubleRange {
    /**
     * Class constructor
     * @param {HTMLElement} element - inputs wrapper element
     * @returns this
     */
    constructor(element) {
        this.element = element;
        this.fromSlider = element.querySelector('[data-component~="double-range-from-slider"]');
        this.fromInput = element.querySelector('[data-component~="double-range-from-input"]');
        this.toSlider = element.querySelector('[data-component~="double-range-to-slider"]');
        this.toInput = element.querySelector('[data-component~="double-range-to-input"]');

        return this.init();
    }

    /**
     * Init class
     * @returns this
     */
    init() {
        return this.initEventListeners().setVariables();
    }

    /**
     * Attach all required event listeners
     * @returns this
     */
    initEventListeners() {
        this.fromSlider.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromSlider, this.toSlider);

            if (from > to) {
                this.fromSlider.value = to;
                this.fromInput.value = to;
            } else {
                this.fromInput.value = from;
            }

            this.setVariables();
        });

        this.fromInput.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromInput, this.toInput);

            if (from > to) {
                this.fromSlider.value = to;
                this.fromInput.value = to;
            } else {
                this.fromSlider.value = from;
            }

            this.setVariables();
        });

        this.toSlider.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromSlider, this.toSlider);

            this.toInput.value = from <= to ? to : from;
            this.toSlider.value = from <= to ? to : from;

            this.setVariables();
        });

        this.toInput.addEventListener('input', () => {
            const [from, to] = this.getValue(this.fromInput, this.toInput);

            if (from <= to) {
                this.toSlider.value = to;
                this.toInput.value = to;
            } else {
                this.toInput.value = from;
            }

            this.setVariables();
        });
        // Empêcher scroll pendant le drag
        [this.fromSlider, this.toSlider].forEach(slider => {
            ['mousedown', 'touchstart'].forEach(evt => {
                slider.addEventListener(evt, () => {
                    document.body.style.overflow = 'hidden';
                }, { passive: false });
            });
        });

        ['mouseup', 'touchend'].forEach(evt => {
            document.addEventListener(evt, () => {
                document.body.style.overflow = '';
            });
        });

        return this;
    }

    /**
     * Get two input numeric values
     * @param {HTMLInputElement} fromInput - least value input
     * @param {HTMLInputElement} toInput - greatest value input
     * @returns [Number, Number]
     */
    getValue(fromInput, toInput) {
        return [Number(fromInput.value), Number(toInput.value)];
    }

    /**
     * Set CSS variables and other attributes according to the current values
     * @returns this
     */
    setVariables() {
        const min = Number(this.fromInput.min);
        const max = Number(this.fromInput.max);
        const fromVal = Number(this.fromInput.value);
        const toVal = Number(this.toInput.value);

        const fromPercent = ((fromVal - min) / (max - min)) * 100;
        const toPercent = ((toVal - min) / (max - min)) * 100;

        // labels
        const fromLabel = this.element.querySelector('.year-label-from');
        const toLabel = this.element.querySelector('.year-label-to');
        if (fromLabel) {
            fromLabel.querySelector('.year-label-text').textContent = fromVal;
            fromLabel.style.left = `${fromPercent}%`;
        }
        if (toLabel) {
            toLabel.querySelector('.year-label-text').textContent = toVal === max ? "Aujourd'hui" : toVal;
            toLabel.style.left = `${toPercent}%`;
        }

        // CSS variables pour track actif
        this.element.style.setProperty('--from-position', `${fromPercent}%`);
        this.element.style.setProperty('--to-position', `${toPercent}%`);

        return this;
    }
}

document.addEventListener('DOMContentLoaded', function () {
    for (let element of document.querySelectorAll('[data-component~="double-range"]')) {
        element.doubleRange = new DoubleRange(element);
        element.doubleRange.setVariables(); // initialise positions et labels dès le chargement
    }
});